module.exports = __webpack_public_path__ + "img/joinourdiscord.92426410.svg";